export const EnumModalName = {
  createObject: "create-object",
  successCreate: "success-create",
  countrySearch: "country-search",
  subscribe: "subscribe",
  gallery: "gallery",
  authRequired: "auth-required",
  shareLink: "share-link",
  callBack: "call-back",
  messengerNotInstalled: "messenger-not-installed",
  resetPassword: "reset-password",
} as const;

export type ModalType = (typeof EnumModalName)[keyof typeof EnumModalName];
